import { Injectable } from '@angular/core';
import { Config, driver, Driver, DriveStep } from 'driver.js';

@Injectable()
export class GuideDriverAdapterService {
  private readonly driverInstance: Driver = driver();

  getDriverInstance(): Driver {
    return this.driverInstance;
  }

  setConfig(config: Config): void {
    this.driverInstance.setConfig(config);
  }

  setSteps(steps: DriveStep[]): void {
    this.driverInstance.setSteps(steps);
  }

  start(stepIndex?: number): void {
    this.driverInstance.drive(stepIndex);
  }

  refresh(): void {
    this.driverInstance.refresh();
  }

  moveNext(): void {
    this.driverInstance.moveNext();
  }

  movePrevious(): void {
    this.driverInstance.movePrevious();
  }

  moveTo(stepIndex: number): void {
    this.driverInstance.moveTo(stepIndex);
  }

  destroySafely(): void {
    try {
      this.driverInstance.destroy();
    } catch (error) {
      console.warn('Guide driver destroy failed', error);
    }
  }
}
